export default "__VITE_PUBLIC_ASSET__dfaa1985__"